import { CreateUserParams, GetUsersParams } from "@/api/user/interface";
import { FilterUser, FilterUsers, UserModal } from "#/organisms";
import { useCallback, useEffect, useRef, useState } from "react";
import { useFilter, useModal } from "@/hooks";

import { User } from "@/types";
import { Users } from "#/pages";
import { useApi } from "@/api";

const UsersView = () => {
  const { user } = useApi();
  const {
    filter,
    numberOfFilters,
    onOpenFilter,
    setShouldFilter,
    shouldFilter,
    showFilter,
    ...filterProps
  } = useFilter<FilterUser>();
  const { showModal, onCloseModal, onOpenModal } = useModal();
  const [loadingUser, setLoadingUsers] = useState(false);
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [currentUserId, setCurrentUserId] = useState<string | undefined>();
  const [called, setCalled] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const userRef = useRef<User[]>([]);

  const getUsersList = async (filterData?: GetUsersParams) => {
    setLoadingUsers(true);
    await user.getUsers(filterData);
    setLoadingUsers(false);
  }

  useEffect(() => {
    if (!called) {
      setCalled(true)
      getUsersList();
    }
  }, [user.users, called]);

  useEffect(() => {
    if (shouldFilter) {
      if (filter) {
        getUsersList({
          displayName: filter.name,
          isActive: filter.active || null,
          isAdmin: filter.admin || null,
          loginName: filter.email,
          page: '',
        });
      } else {
        getUsersList();
      }
      setShouldFilter(false);
    }
  }, [filter, shouldFilter]);

  useEffect(() => {
    userRef.current = user.users;
  }, [user.users]);


  const handleNewUser = useCallback(async (newUser: CreateUserParams) => {
    if (isEdit) {
      await user.updateAccount(newUser);
    } else {
      await user.createUser(newUser);
    }
  
    onCloseModal();
  }, [isEdit]);

  const handleNewUserModal = () => {
    setIsEdit(false);
    setCurrentUser(null);
    onOpenModal();
  };

  const handleEditUser = useCallback(async (userId: string) => {
    setIsEdit(true);
    const userToEdit = userRef.current.find((item) => item.id === userId);

    if (userToEdit)
    {
      setCurrentUser(userToEdit)
      setCurrentUserId(userId);
      onOpenModal();
    }
  }, [user, user.users]);

  const handleDeleteUser = useCallback(async (userId: string) => {
    user.deleteUser(userId);
    onCloseModal();
  }, []);

  return (
    <>
      { user.users.length > 0 &&
      <><Users loading={loadingUser} users={user.users} numberOfFilters={numberOfFilters}
          onNewUser={handleNewUserModal} onOpenFilter={onOpenFilter} onOpenEditModal={handleEditUser} onDelete={handleDeleteUser}  />
      {showFilter && <FilterUsers {...filterProps} filter={filter} numberOfFilters={numberOfFilters} />}
      {showModal && (
        <UserModal onClose={onCloseModal} onSubmit={handleNewUser} type={isEdit ? 'edit' : 'create'} user={currentUser} userId={currentUserId} />
      )}</> }
    </>
  );
}

export default UsersView;